/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Category_SubtitleInputs */

const vi_shop_category_subtitle = /** @type {(inputs: Shop_Category_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dùng chung web + Zalo Mini App; kéo ⋮⋮ để đổi thứ tự hiển thị.`)
};

/**

* @param {Shop_Category_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_category_subtitle = /** @type {((inputs?: Shop_Category_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Category_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_category_subtitle(inputs)
});